import { render, staticRenderFns } from "./PresaleChat.vue?vue&type=template&id=16ec021e&scoped=true"
import script from "./PresaleChat.vue?vue&type=script&lang=js"
export * from "./PresaleChat.vue?vue&type=script&lang=js"
import style0 from "./PresaleChat.vue?vue&type=style&index=0&id=16ec021e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ec021e",
  null
  
)

export default component.exports